
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { useTranslations } from "@/hooks/useTranslations";

interface NutritionSearchProps {
  searchTerm: string;
  setSearchTerm: (value: string) => void;
}

export function NutritionSearch({ searchTerm, setSearchTerm }: NutritionSearchProps) {
  const { t } = useTranslations("nutrition");
  
  return (
    <div className="relative">
      <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground dark:text-gray-400" />
      <Input
        type="search"
        placeholder={t("search.placeholder")}
        className="pl-8 bg-white dark:bg-gray-800 dark:text-white dark:border-gray-700 dark:placeholder:text-gray-400"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
    </div>
  );
}
